<template>
  <div class="c-my-music-expand-playlists">
    <!-- <div class="playlists-box">
          <img class="playlists-box__img" src="@/assets/myMusic/icon_favourite.svg" />
          <span class="playlists-box__text">加入收藏</span>
        </div> -->

    <div class="playlists-box">
      <img class="playlists-box__img" src="@/assets/myMusic/icon_video_music.svg" />
      <span class="playlists-box__text">{{ $t('myMusic.myTracks') }}</span>
    </div>

    <ul class="playlists-list">
      <li class="playlists-list__item" v-for="item of trackList" :key="item.key" @click="toPlaylistsPage(item)">
        <div class="playlists-list__item__box">
          <!-- <div class="playlists-list__item__box__img"></div> -->
          <img class="playlists-list__item__box__img" v-show="item.isFavourite"
            src="@/assets/myMusic/icon_favourite.svg" />
          <p class="playlists-list__item__box__text">
            <span class="playlists-list__item__box__text__name">{{ renderName(item, 'tracks') }}</span>
            <span class="playlists-list__item__box__text__count">({{ addCommas(item.count) }})</span>
          </p>
        </div>
      </li>
    </ul>

    <div class="playlists-box playlists-box--margin-top">
      <img class="playlists-box__img" src="@/assets/icon/icon_album_1.svg" />
      <span class="playlists-box__text">{{ $t('myMusic.myAlbums') }}</span>
    </div>

    <ul class="playlists-list">
      <li class="playlists-list__item" v-for="item of albumList" :key="item.key" @click="toAlbumPage(item)">
        <div class="playlists-list__item__box">
          <!-- <div class="playlists-list__item__box__img"></div> -->
          <img class="playlists-list__item__box__img" v-show="item.isFavourite"
            src="@/assets/myMusic/icon_favourite.svg" />
          <p class="playlists-list__item__box__text">
            <span class="playlists-list__item__box__text__name">{{ renderName(item, 'albums') }}</span>
            <span class="playlists-list__item__box__text__count">({{ addCommas(item.count) }})</span>
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { defineComponent, computed, onMounted } from 'vue';
// import { useMessage } from 'naive-ui';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
// getAccountPlaylistListAPI
// import { getAccountFavouriteAPI } from '@/api/myMusicPlaylists';
// import useRequest from '@/hooks/useRequest';
import addCommas from '@/utils/addCommas';
import { useMyMusicStore } from '@/store/myMusic';
import useAccountPlaylistList from '@/hooks/useAccountPlaylistList';

export default defineComponent({
  name: 'MyMusicExpandPlaylist',
  props: {
    closeMyMusic: {
      type: Function,
      default: () => { },
    },
  },
  setup(props) {
    const { t } = useI18n();
    const { fetchAllPlaylist } = useAccountPlaylistList();
    // const trackList = ref([]);
    // const albumList = ref([]);
    // const { request } = useRequest(getAccountPlaylistListAPI);
    // const { request: getAccountFavouriteRequest } = useRequest(getAccountFavouriteAPI);
    // const message = useMessage();
    const router = useRouter();
    const myMusicStore = useMyMusicStore();

    const trackList = computed(() => myMusicStore.accountPlaylistList.trackList);
    const albumList = computed(() => myMusicStore.accountPlaylistList.albumList);

    const toPlaylistsPage = (data) => {
      router.push({
        name: 'my-music-playlists',
        query: {
          type: 'tracks',
          pageIndex: 1,
          expandUid: data.accountPlaylistUid,
        },
      });

      props.closeMyMusic();
    };

    const toAlbumPage = (data) => {
      router.push({
        name: 'my-music-playlists',
        query: {
          type: 'albums',
          pageIndex: 1,
          expandUid: data.accountPlaylistUid,
        },
      });

      props.closeMyMusic();
    };

    const renderName = (data, type) => {
      if (!data.isFavourite && data.name) {
        return data.name;
      }

      if (data.isFavourite) {
        return type === 'tracks' ? t('myMusic.favouriteTracks') : t('myMusic.favouriteAlbums');
      }

      return '';
    };

    onMounted(() => {
      fetchAllPlaylist();
    });

    return {
      trackList,
      albumList,
      renderName,
      toPlaylistsPage,
      toAlbumPage,
      addCommas,
    };
  },
});
</script>
<style lang="scss" scoped>
.playlists-box {
  @include flex();
  cursor: pointer;

  &--margin-top {
    margin-top: 20px;
  }

  &+& {
    margin-top: 22px;
  }

  &__img {
    width: 22px;
  }

  &__text {
    @include font-style($c-black, 14, 700, 1.4px, 26px);
    margin-left: 12px;
  }
}

.playlists-list {
  width: 100%;
  margin-top: 20px;
  @include padding(0 0 0 35px);

  &__item {
    width: 100%;
    @include flex();
    @include padding(0 15px);
    border-radius: 5px;
    background-color: $c-white;
    height: 40px;
    cursor: pointer;

    &:hover {
      background-color: $c-assist2;

    }

    &+& {
      margin-top: 12px;
    }

    &__box {
      @include flex();

      &__img {
        width: 13px;
        height: 13px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        display: inline-block;
        margin-right: 10px;
      }

      &__text {
        width: 100%;
        @include flex();

        &__name {
          @include font-style($c-black, 14, normal, 0.7px, 20px);
          @include word-ellipsis(1);
          flex: 1;
        }

        &__count {
          margin-left: 5px;
          @include font-style($c-assist4, 14, normal, 0.7px, 20px);
          flex: none;
          width: 30px;
        }
      }
    }
  }
}
</style>
